import DOMPurify from "dompurify";
export function encodeHTML(x) {
  const node = document.createElement("div");
  node.innerText = x;
  return node.innerHTML;
}
export function sanitizeUrl(url) {
  // let DOMPurify enforce protocol safety
  const safe = DOMPurify.sanitize(`<a href="${url}"></a>`);
  const match = safe.match(/href="([^"]*)"/);
  return match ? match[1] : "";
}

export function safeRedirect(url) {
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
